import { AgeClassificationService } from '@/modules/global-settings/miscellaneous/services/age-classification.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

const service = new AgeClassificationService();

export const state = {
  ageClassification: null
};

export const mutations = {
  ...make.mutations(state)
};

export const actions = {
  getAgeClassification: async ({ commit }) => {
    try {
      const { data } = await service.getAgeClassification();
      commit('SET_AGE_CLASSIFICATION', data);
      return data;
    } catch (error) {
      Logger.error('getting age classification settings', error);
      throw error;
    }
  }
};

export const getters = {
  ...make.getters(state),
  youthAgeMaximumSetting(state) {
    const val = state.ageClassification?.youthAgeMaximum;
    if (val === undefined || val === null || val === 0) {
      return 18;
    }
    return Number(val);
  },
  seniorCitizenAgeMinimumSetting(state) {
    const val = state.ageClassification?.seniorCitizenAgeMinimum;
    if (val === undefined || val === null || val === 0) {
      return 65;
    }
    return Number(val);
  }
};
